import { useQuery } from '@tanstack/react-query';
import { taxonomyApi } from '../api/taxonomy-api';
import type { CategoryKind } from './types';

export const taxonomyKeys = {
  all: ['taxonomy'] as const,
  categories: (kinds?: readonly CategoryKind[]) =>
    [...taxonomyKeys.all, 'categories', [...(kinds ?? [])].sort().join(',')] as const,
  hsCodes: (q: string) => [...taxonomyKeys.all, 'hs-codes', q] as const,
};

export function useCategoriesQuery(kinds?: CategoryKind[]) {
  return useQuery({
    queryKey: taxonomyKeys.categories(kinds),
    queryFn: () => taxonomyApi.listCategories(kinds),
    staleTime: 60 * 60_000,
  });
}

export function useHsCodesQuery(q: string, enabled = true) {
  return useQuery({
    queryKey: taxonomyKeys.hsCodes(q),
    queryFn: () => taxonomyApi.searchHsCodes(q),
    enabled: enabled && q.length >= 2,
    staleTime: 5 * 60_000,
  });
}
